import React from "react";
import { LEGAL_TERMS_URL } from "../config/legalUrls";
import LegalMarketingRedirect from "./LegalMarketingRedirect";

const TermsOfUsePage = () => (
  <LegalMarketingRedirect url={LEGAL_TERMS_URL} testId="terms-of-use-page" />
);

export default TermsOfUsePage;
